import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export function useExchangeMergePublicTokenForToken () {
  return useMutation<void, GrapeAPIErrorType, { publicToken: string }>({
    mutationFn: async ({ publicToken }) => {
      const response = await fetchWithHeaders(
        '/api/web/payroll/merge/exchange_public_token',
        {
          method: 'POST',
          body: JSON.stringify({ public_token: publicToken }),
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
    },
  })
}
